<template>
  <div class="container page">
    <h1>{{ $t('nav.contact') }}</h1>
    <contact />
  </div>
</template>
<script>import Contact from '@/components/Contact.vue';export default {components:{Contact}}</script>
